module.exports = "/images/Qatar.png?41bd663af553e2e664a43ad7636be5d0";